import * as React from "react";
import { forwardRef } from "react";
const SvgHamburger = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 18, height: 18, viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", "data-svgr-icon": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M2.25 4.5H15.75M2.25 9H15.75M2.25 13.5H15.75", stroke: "white", strokeWidth: 1.5, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgHamburger);
export { ForwardRef as ReactComponent };
